module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAABL0lEQVQ4T+2UO0sDQRSFv7MhsJ1iIaKilqJgIsFHyApaiWJpJ1go+B9sJNj4HwQbwc5SFGtXfEBQLKKlglhYBO0CIXslZgmig7CpM+Wdc76ZudwzwrEsmJjBvANgPN4uo2hD4cPNb7mcgEL2GdkVfEOAaBNTXpf3I06A5XJd+PVpRDfIx+wQo4hHuelnDFFEWgerYnxQTd2qVPqUFTILoGOgx3Wbf2oVsNUG4BE0mtAcy+1JVshW2jM3Xc4mJgHK5qf6qNVOkpha2nR6RRbkhrD6S1sApYYdAC1DNAvawdiKH7oPtgveNdhp6zAnQDYHXoDZHrAWi4+QtiEKMV10AJ0e/J2DfGYAT68/RvkN8OP/4T2u9wKN1FaB/pY2skFZI5HB5Blmi4nyIJ0T3i19AaRWzWreF7k9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/icon_delete@2x.png
// module id = hs6w
// module chunks = 69